import React, { useEffect, useState } from 'react';
import { TOKEN, LIVE_STATS } from '../data/mock';

const DEX_URL = `https://api.dexscreener.com/latest/dex/tokens/${TOKEN.contract}`;

function fmtUsd(n) {
  if (n == null || isNaN(n)) return null;
  if (n >= 1_000_000_000) return `$${(n / 1_000_000_000).toFixed(2)}B`;
  if (n >= 1_000_000) return `$${(n / 1_000_000).toFixed(2)}M`;
  if (n >= 1_000) return `$${(n / 1_000).toFixed(2)}K`;
  if (n >= 1) return `$${n.toFixed(2)}`;
  // very small price
  if (n >= 0.01) return `$${n.toFixed(4)}`;
  if (n >= 0.0001) return `$${n.toFixed(6)}`;
  return `$${n.toExponential(2)}`;
}

function fmtPct(n) {
  if (n == null || isNaN(n)) return null;
  const sign = n >= 0 ? '+' : '';
  return `${sign}${n.toFixed(2)}%`;
}

export default function LiveTicker() {
  const [stats, setStats] = useState({
    mcap: LIVE_STATS.mcap,
    change24h: LIVE_STATS.change24h,
    price: LIVE_STATS.price,
    liq: LIVE_STATS.liq,
    live: false,
    error: false,
  });

  useEffect(() => {
    let cancelled = false;

    const load = async () => {
      try {
        const r = await fetch(DEX_URL, { cache: 'no-store' });
        if (!r.ok) throw new Error(`http ${r.status}`);
        const data = await r.json();
        const pairs = Array.isArray(data?.pairs) ? data.pairs : [];
        if (!pairs.length) {
          if (!cancelled) setStats((s) => ({ ...s, live: false, error: false }));
          return;
        }
        // Pick the pair with the highest USD liquidity (most representative)
        const pair = pairs.reduce((a, b) => {
          const la = Number(a?.liquidity?.usd || 0);
          const lb = Number(b?.liquidity?.usd || 0);
          return lb > la ? b : a;
        });

        const priceUsd = Number(pair?.priceUsd);
        const change24 = Number(pair?.priceChange?.h24);
        const liqUsd = Number(pair?.liquidity?.usd);
        const mcapUsd = Number(pair?.marketCap ?? pair?.fdv);

        if (!cancelled) {
          setStats({
            mcap: fmtUsd(mcapUsd) || '—',
            change24h: fmtPct(change24) || '—',
            price: fmtUsd(priceUsd) || '—',
            liq: fmtUsd(liqUsd) || '—',
            live: true,
            error: false,
          });
        }
      } catch (e) {
        if (!cancelled) setStats((s) => ({ ...s, live: false, error: true }));
      }
    };

    load();
    const id = setInterval(load, 30_000);
    return () => { cancelled = true; clearInterval(id); };
  }, []);

  const changeIsUp = typeof stats.change24h === 'string' && stats.change24h.startsWith('+');

  return (
    <div className="ticker font-sans">
      <span>
        <span className={`live-dot ${stats.live ? '' : 'idle'}`} />
        {stats.live ? 'LIVE' : 'LIVE·'}
      </span>
      <span className="sep">|</span>
      <span><span className="label">MCAP</span>{stats.mcap}</span>
      <span className="sep">|</span>
      <span>
        <span className="label">24H</span>
        <span className={changeIsUp ? 'up' : 'down'}>{stats.change24h}</span>
      </span>
      <span className="sep">|</span>
      <span><span className="label">PRICE</span>{stats.price}</span>
      <span className="sep">|</span>
      <span><span className="label">LIQ</span>{stats.liq}</span>
    </div>
  );
}
